<template>
  <Drawer class="setCustomizedContentDrawer_box" :title="setCustomizedContentTitle" v-model="setCustomizedContentModal" width="1000"
    :mask-closable="setCustomizedContentType === 'look'" :closable="true" @on-visible-change="setCustomizedContentChange" :before-close="handleBeforeClose">
    <Form class="setCustomizedContent_box" ref="customInfoForm" :model="customInfoForm" :label-width="170"
      @submit.native.prevent :disabled="setCustomizedContentType === 'look'">
      <!--定制收费-->
      <h2 class="title_box mb10 font-weight-bold font-size-15 color-333">{{ $t('key1001316') }}</h2>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001229')" :label-width="70" prop="customizationChargingMode" class="radio_styles" style="top: -1px;">
            <RadioGroup v-model="customInfoForm.customizationChargingMode">
              <Radio v-for="item in chargingModeList" :label="item.value">{{ item.name }}</Radio>
            </RadioGroup>
            <p class="font-size-13 color-666">{{ chargingModeConter }}</p>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="customInfoForm.customizationChargingMode === 2">
          <Form-item :label="partCostName" prop="price" :label-width="200" class="ivu-form-item-required"
            :class="isValueEmpty(customInfoForm.price) || customInfoForm.price <=0 ? 'ivu-form-item-error' : ''">
            <InputNumber style="width: 160px" :min="0" :max="9999999"
              :placeholder="$t('key1001309')"
              :formatter="(value) => formatterNumber(value, 2)" v-model.trim="customInfoForm.price">
            </InputNumber>
            <div class="ivu-form-item-error-tip" v-if="isValueEmpty(customInfoForm.price) || customInfoForm.price <=0">
              {{ $t('key1001317') }}
            </div>
          </Form-item>
        </Col>
      </Row>
      <!--定制信息-->
      <div class="title_box mb15 flex align-items-center justify-content-between">
        <h2 class="font-weight-bold font-size-15 color-333">{{ $t('key1000866') }}</h2>
        <span class="redColor font-size-13" v-if="alreadyShelvedCustomizedProducts">
          {{ $t('key1001318') }}
        </span>
        <Button type="primary" v-if="setCustomizedContentType !== 'look' && !alreadyShelvedCustomizedProducts" class="mr8 mb3" :disabled="addCustomizedContentTalg"
          size="small" @click="addCustomizedPartsBtn">{{ $t('key1001319') }}</Button>
      </div>
      <div class="customInfo_box" ref="customInfoBox">
        <Row v-for="(item,index) in customInfoList" class="customInfo_box_item">
          <Icon class="deleteCustomInfo_icon" color="#F41C0E" type="ios-trash-outline" size="30" v-if="customInfoList.length >1 && setCustomizedContentType !== 'look'"
            @click="deleteCustomInfoBtn(index)"/>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001310')" prop="ymsProductCategoryPositionId" class="ivu-form-item-required"
              :class="item.requiredTalg && !item.ymsProductCategoryPositionId ? 'ivu-form-item-error' : ''">
              <Select v-model.trim="item.ymsProductCategoryPositionId" transfer filterable style="width: 220px"
                @on-change="(value)=>customizedPartsChange(value)" :disabled="alreadyShelvedCustomizedProducts">
                <Option v-for="ele in ymsProductCategoryPositionsList" :disabled="ele.disabled"
                  :value="ele.ymsProductCategoryPositionId">{{ ele.name }}</Option>
              </Select>
              <div class="ivu-form-item-error-tip" v-if="item.requiredTalg && !item.ymsProductCategoryPositionId">{{ $t('key1000719') }}</div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001311')" prop="direction">
              <Input type="textarea" :maxlength="200" :autosize="{ minRows: 4, maxRows: 6}" :showWordLimit="true"
                :placeholder="$t('key1001312')" :disabled="alreadyShelvedCustomizedProducts"
                v-model.trim="item.direction"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001313')" prop="customImgList" class="ivu-form-item-required">
              <div class="imgagesList_box" v-viewer="viewerOptions">
                <div class="imgagesList_box_item" v-for="(path,idx) in item.customImgList" :key="idx">
                  <div class="img_content">
                    <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                    <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
                  </div>
                  <div class="flex align-items-center justify-content-center cursor" v-if="setCustomizedContentType !== 'look' && !alreadyShelvedCustomizedProducts">
                    <span class="font-size-12 themeColor mr6" style="position: relative; top: 1px;" @click="deleteImgBtn(idx, index)">{{ $t('key1000512') }}</span>
                    <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(idx, index)"/>
                  </div>
                </div>
                <Upload
                  v-if="item.customImgList.length < 5 && setCustomizedContentType !== 'look' && !alreadyShelvedCustomizedProducts"
                  name="files"
                  :headers="headObj"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index)"
                  :on-error="uploadFilesError"
                  :before-upload="(file) => handleImgbeforeUpload(file)"
                  multiple
                  :action="uploadFilesUrl"
                  type="drag"
                  style="display: inline-block;width:100px;">
                  <div class="upload-box" :style="item.requiredTalg && item.customImgList.length<=0 ? {width: '98px',border: '1px dashed #ed4014'} : ''">
                    <i class="iconfont upload-icon">&#xe68d;</i>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
              </div>
              <div class="ivu-form-item-error-tip" v-if="item.requiredTalg && item.customImgList.length<=0">{{ $t('key1001320') }}</div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001314')" prop="districtLength" class="ivu-form-item-required"
              :class="item.requiredTalg && (!item.districtLength || !item.districtWidth ||
              item.districtLength <= 0 || item.districtWidth <= 0) ? 'ivu-form-item-error' : ''">
              <div class="flex align-items-center">
                <InputNumber style="width: 100px" :min="0" :max="9999999" :disabled="alreadyShelvedCustomizedProducts"
                  :placeholder="$t('key1000850')" :formatter="value => `${parseInt(value)}`" v-model.trim="item.districtLength">
                </InputNumber>
                <span class="ml6 mr6">*</span>
                <InputNumber style="width: 100px" :min="0" :max="9999999" :disabled="alreadyShelvedCustomizedProducts"
                  :placeholder="$t('key1000851')" :formatter="value => `${parseInt(value)}`" v-model.trim="item.districtWidth">
                </InputNumber>
              </div>
              <div class="ivu-form-item-error-tip"
                v-if="item.requiredTalg && (!item.districtLength || !item.districtWidth || item.districtLength <= 0 || item.districtWidth <= 0)">
                {{ $t('key1001321') }}
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001315')" prop="workmanshipType" class="ivu-form-item-required"
              :class="item.requiredTalg && !item.workmanshipType ? 'ivu-form-item-error' : ''">
              <Select v-model.trim="item.workmanshipType" transfer style="width: 220px" :disabled="alreadyShelvedCustomizedProducts">
                <Option v-for="ele in customizedCraftsmanshipList" :value="ele.value">{{ ele.name }}</Option>
              </Select>
              <div class="ivu-form-item-error-tip" v-if="item.requiredTalg && !item.workmanshipType">{{ $t('key1001322') }}</div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="customInfoForm.customizationChargingMode === 3">
            <Form-item :label="customizationFeeName" prop="price" class="ivu-form-item-required"
              :class="isValueEmpty(item.price) ? 'ivu-form-item-error' : ''">
              <InputNumber style="width: 220px" :min="0" :max="9999999"
                :placeholder="$t('key1001309')"
                :formatter="(value) => formatterNumber(value, 2)" v-model.trim="item.price">
              </InputNumber>
              <div class="ivu-form-item-error-tip" v-if="isValueEmpty(item.price)">{{ $t('key1001323') }}</div>
            </Form-item>
          </Col>
        </Row>
      </div>
    </Form>
    <div class="drawer_footer">
      <template v-if="setCustomizedContentType === 'look'">
        <Button type="primary" @click="setCustomizedContentModal = false">{{ $t('key1000248') }}</Button>
      </template>
      <template v-else>
        <Button class="mr15" @click="cancelBtn">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="setCustomizedContentBtn">{{ $t('key1000111') }}</Button>
      </template>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {formatterNumber, getDataSetBatchList, getEnumList, isValueEmpty} from "@/utils/common";

export default {
  name: 'setCustomizedContentDrawer',
  mixins: [Mixin],
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    alreadyShelvedCustomizedProducts: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let v = this;
    return {
      setCustomizedContentModal: false,
      setCustomizedContentTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001300'),
      setCustomizedContentType: null,
      customInfoForm: {
        customizationChargingMode: 1,
        price: null,
      },
      customInfoList: [
        {
          ymsProductCategoryPositionId: null,
          direction: '',
          customImgList: [],
          districtWidth: null,
          districtLength: null,
          workmanshipType: null,
          price: null,
          requiredTalg: false,
        }
      ],
      currentIndex: 0,
      ymsProductCategoryPositionsList: [],
      enumData: [],
    }
  },
  computed: {
    chargingModeConter() {
      let obj = {
        1: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001301'),
        2: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001302'),
        3: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001303'),
      }
      return obj[this.customInfoForm.customizationChargingMode]
    },
    partCostName() {
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001304') + this.currencyState + ')：'
    },
    customizationFeeName() {
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001305') + this.currencyState + ')：'
    },
    uploadFilesUrl() {
      return this.system === 'yms' ? api.post_uploadFiles + '?basePath=yms-core-service&action="uploadimage"' :
        api.post_uploadFiles + '?basePath=yms-supplier-service&action="uploadimage"';
    },
    addCustomizedContentTalg() {
      return this.ymsProductCategoryPositionsList.every(item => item.disabled === true) ||
        this.customInfoList.length >= this.ymsProductCategoryPositionsList.length;
    },
    // 定制工艺
    customizedCraftsmanshipList() {
      const ENUM_KEY = this.system === 'yms' ? 'YmsProductGoodsPositionWorkmanshipTypeCoreEnum' : 'ProductGoodsPositionWorkmanshipTypeSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 收费模式
    chargingModeList() {
      const ENUM_KEY = this.system === 'yms' ? 'YmsProductGoodsCustomizationChargingModeCoreEnum' : 'ProductGoodsCustomizationChargingModeSupplierEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    }
  },
  methods: {
    isValueEmpty,
    formatterNumber,
    // 初始化数据
    async initSetCustomizedContentData(type, data, currentIndex, ymsProductCategoryPositionsList = []) {
      this.ymsProductCategoryPositionsList = [];
      let enumKeyList = [];
      if (this.system === 'yms') {
        enumKeyList = ['YmsProductGoodsPositionWorkmanshipTypeCoreEnum', 'YmsProductGoodsCustomizationChargingModeCoreEnum'];
      } else {
        enumKeyList = ['ProductGoodsPositionWorkmanshipTypeSupplierEnum', 'ProductGoodsCustomizationChargingModeSupplierEnum'];
      }
      this.enumData = await getDataSetBatchList(enumKeyList);

      this.setCustomizedContentTitle = this.system === 'yms' || type === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001306') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001300');
      this.currentIndex = currentIndex;
      this.setCustomizedContentType = type;
      let {customizationChargingMode, productGoodsPositions = []} = data;
      this.customInfoForm.customizationChargingMode = customizationChargingMode || 1;
      if (customizationChargingMode === 2) {
        let price = productGoodsPositions?.[0].price || 0;
        this.customInfoForm.price = Number(price.toFixed(2));
      }
      if (productGoodsPositions.length > 0) {
        let newList = [];
        let ymsProductCategoryPositionIdList = [];
        productGoodsPositions.map((item) => {
          let customImgList = [];
          let productGoodsPositionImages = item.productGoodsPositionImages || [];
          if (productGoodsPositionImages.length > 0) {
            customImgList = productGoodsPositionImages.map((ele) => {
              return ele.path
            });
          }
          if (item.ymsProductCategoryPositionId) {
            ymsProductCategoryPositionIdList.push(item.ymsProductCategoryPositionId);
          }
          newList.push({
            ymsProductCategoryPositionId: item.ymsProductCategoryPositionId,
            direction: item.direction,
            customImgList: customImgList,
            districtWidth: item.districtWidth,
            districtLength: item.districtLength,
            workmanshipType: item.workmanshipType,
            price: item.price,
            requiredTalg: false,
          })
        });
        this.customInfoList = newList;
        ymsProductCategoryPositionsList.forEach(item => {
          item.disabled = false;
          if (ymsProductCategoryPositionIdList.includes(item.ymsProductCategoryPositionId)) {
            item.disabled = true;
          }
        });
        this.ymsProductCategoryPositionsList = ymsProductCategoryPositionsList;
      } else {
        this.customInfoList = [
          {
            ymsProductCategoryPositionId: null,
            direction: '',
            customImgList: [],
            districtWidth: null,
            districtLength: null,
            workmanshipType: null,
            price: null,
            requiredTalg: false,
          }
        ];
        this.ymsProductCategoryPositionsList = ymsProductCategoryPositionsList;
      }
      this.setCustomizedContentModal = true;
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.setCustomizedContentModal = false;
      });
    },
    // 确定按钮
    setCustomizedContentBtn() {
      const getPriceByMode = (customizationChargingMode, modePrice, price) => {
        if (customizationChargingMode === 1) return 0;
        if (customizationChargingMode === 2) return Number(price.toFixed(2));
        if (customizationChargingMode === 3) return Number(modePrice.toFixed(2)); // 根据实际需求调整
        return 0;
      };

      const {customizationChargingMode, price} = this.customInfoForm;
      const fieldsToCheck = ['ymsProductCategoryPositionId', 'districtWidth', 'districtLength', 'workmanshipType'];
      if (customizationChargingMode === 3) {
        fieldsToCheck.push('price');
      }
      // 费用校验
      if (customizationChargingMode === 2) {
        if (isValueEmpty(price)) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001307'));
          return false;
        }
        if (price <= 0) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001308'));
          return false;
        }
      }
      let allValid = true;
      this.customInfoList.forEach((item, index) => {
        const fieldsValid = fieldsToCheck.every(field => {
          const value = item[field];
          if (field === 'districtWidth' || field === 'districtLength') {
            return value != null && value !== '' && !isNaN(value) && Number(value) > 0;
          }
          return value != null && value !== '';
        });

        const imgValid = Array.isArray(item.customImgList) && item.customImgList.length > 0;
        const isItemValid = fieldsValid && imgValid;
        if (!isItemValid) {
          item.requiredTalg = true;
          allValid = false;
        } else {
          item.requiredTalg = false;
        }
      });
      if (allValid) {
        const productGoodsPositionsList = this.customInfoList.map((item, index) => {
          const partsName = this.ymsProductCategoryPositionsList.find(e => e.ymsProductCategoryPositionId === item.ymsProductCategoryPositionId)?.name || '';
          return {
            parts: partsName,
            ymsProductCategoryPositionId: item.ymsProductCategoryPositionId,
            districtLength: item.districtLength,
            districtWidth: item.districtWidth,
            sortNo: index + 1,
            price: getPriceByMode(customizationChargingMode, item.price, price),
            currency: this.currencyState,
            direction: item.direction,
            workmanshipType: item.workmanshipType,
            productGoodsPositionImages: item.customImgList.map(k => ({
              path: k,
              type: 1,
            })),
          };
        });
        const obj = {
          isCustomization: productGoodsPositionsList.length > 0 ? 1 : 0,
          customizationChargingMode,
          productGoodsPositions: productGoodsPositionsList,
          currentIndex: this.currentIndex,
        };
        this.$emit('updateCustomizedContent', obj);
        this.setCustomizedContentModal = false;
      } else {
        // 校验失败逻辑
        this.$nextTick(() => {
          const container = this.$refs.customInfoBox;
          if (container) {
            const errorNode = container.querySelector('.ivu-form-item-error');
            if (errorNode) {
              errorNode.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
          }
        });
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001307'));
        return false;
      }
    },
    // 重置数据
    resetData() {
      this.$refs['customInfoForm'].resetFields();
      this.customInfoList = [];
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose() {
      let v = this;
      return new Promise((resolve, reject) => {
        if (v.setCustomizedContentType !== 'look') {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              v.resetData();
              resolve();
            },
            onCancel: () => {
              reject();
            }
          });
        } else {
          resolve();
        }
      });
    },
    // 添加定制部位
    addCustomizedPartsBtn() {
      this.customInfoList.push({
        ymsProductCategoryPositionId: null,
        direction: '',
        customImgList: [],
        districtWidth: null,
        districtLength: null,
        workmanshipType: null,
        price: null,
        requiredTalg: false
      });
      this.$nextTick(() => {
        const box = this.$refs.customInfoBox;
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      });
      this.$forceUpdate();
    },
    // 删除定制部位
    deleteCustomInfoBtn(index) {
      this.customInfoList.splice(index, 1);
      this.ymsProductCategoryPositionsList.forEach(item => {
        item.disabled = false;
        this.customInfoList.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.ymsProductCategoryPositionId) {
            item.disabled = true;
          }
        })
      })
      this.$forceUpdate();
    },
    // 选择定制部位
    customizedPartsChange(value) {
      this.ymsProductCategoryPositionsList.forEach(item => {
        item.disabled = false;
        this.customInfoList.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.ymsProductCategoryPositionId) {
            item.disabled = true;
          }
        });
      });
    },
    // 上传图片之前的校验
    handleImgbeforeUpload(file, type) {
      const maxSize = 5;
      return new Promise((resolve, reject) => {
        const isJPG = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
        const isLtMax = file.size / 1024 / 1024 <= maxSize;

        if (!isJPG) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000710'));
          reject();
        }
        if (!isLtMax) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000711'));
          reject();
        }
        resolve();
      });
    },
    // 上传图片成功
    uploadImageSuccess(response, file, fileList, index) {
      if (response.code === 0 && response.datas) {
        let url = response.datas[0];
        if (url) {
          this.customInfoList[index].customImgList.push(url);
          this.customInfoList[index].customImgList = this.customInfoList[index].customImgList.slice(0, 5);
        }
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      } else {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
      }
    },
    // 删除图片
    deleteImgBtn(imgIdx, infoIdx) {
      this.customInfoList[infoIdx].customImgList.splice(imgIdx, 1);
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000712'));
      this.$forceUpdate();
    },
    // 监听抽屉
    setCustomizedContentChange(value) {
      if (!value) {
        if (this.systemTalg) {
          this.resetData();
        }
        this.ymsProductCategoryPositionsList = [];
        this.customInfoList = [
          {
            ymsProductCategoryPositionId: null,
            direction: '',
            customImgList: [],
            districtWidth: null,
            districtLength: null,
            workmanshipType: null,
            price: null,
            requiredTalg: false,
          }
        ]
      }
    }
  }
};
</script>

<style lang="less" scoped>
.setCustomizedContentDrawer_box {
  /deep/ .ivu-drawer-body {
    padding: 16px 16px 0 16px;

    .setCustomizedContent_box {
      .ivu-form-item-label {
        font-size: 14px !important;
        padding-right: 0 !important;
      }

      .title_box {
        line-height: 30px;
        border-bottom: 1px solid #e8eaec;
      }

      .customInfo_box {
        padding-right: 14px;
        padding-bottom: 60px;
        max-height: 615px;
        overflow-y: auto;
        z-index: 10000;

        .customInfo_box_item {
          border-radius: 5px;
          border: 2px solid #DAEAFD;
          background-color: #FBFDFF;
          padding: 15px 60px 0 10px;
          margin-bottom: 15px;
          position: relative;

          .imgagesList_box {
            display: flex;
            flex-wrap: wrap;

            .imgagesList_box_item {
              margin: 0 16px 24px 0;

              .img_content {
                position: relative;
                cursor: pointer;
                width: 100px;
                height: 100px;

                .clickOnCrop_box {
                  width: 100%;
                  height: 20px;
                  line-height: 20px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 10;
                  text-align: center;
                  font-size: 13px;
                  color: #fff;
                  background-color: #ada9a9;
                  display: none;
                }

                &:hover {
                  .clickOnCrop_box {
                    display: inline-block;
                  }
                }
              }

              .img-styles {
                width: 100px;
                height: 100px;
                object-fit: cover;
                border: 1px solid #ddd;
              }
            }

            .upload-box {
              width: 100px;
              height: 100px;
              color: #999999;
              transition: color 0.1s ease-in;
              background: #fff;
              border: 1px dashed #dcdee2;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .upload-icon {
                font-size: 40px;
                display: block;
                margin-bottom: 10px;
              }

              &:hover {
                color: #666666;
              }
            }
          }

          .deleteCustomInfo_icon {
            position: absolute;
            top: 14px;
            right: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .drawer_footer {
    width: 1000px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    text-align: left;
    padding: 12px 0 12px 15px;
    background-color: #fff;
    z-index: 100;
  }
}
</style>
